module.exports = __webpack_public_path__ + "static/media/edit-account-icon.aae66e63.svg";